import { Calendar, MapPin, Swords } from "lucide-react";

function fmt(iso) {
  try {
    const d = new Date(iso);
    return `${d.toLocaleDateString("en-US", { month: "short", day: "numeric" })} · ${d.toLocaleTimeString("en-US", { hour: "numeric", minute: "2-digit" })}`;
  } catch {
    return "";
  }
}

export default function FightCard({ event }) {
  const { status, league, event_name, fighter_a, fighter_b, weight_class, location, start, moneyline } = event;
  return (
    <div className="panel panel-hover p-5 flex flex-col gap-3" data-testid={`fight-card-${event.id}`}>
      <div className="flex items-center justify-between">
        <span className="text-xs font-bold tracking-widest text-smasher-gold">{league} · FIGHT CARD</span>
        <span className={`text-[10px] font-bold px-2 py-0.5 rounded border ${status === "final" ? "bg-slate-700/50 text-slate-300 border-slate-600" : "bg-smasher-gold/15 text-smasher-gold border-smasher-gold/30"}`}>
          {status === "final" ? "FINAL" : "UPCOMING"}
        </span>
      </div>
      <div className="text-sm font-semibold text-slate-200">{event_name}</div>
      <div className="flex items-center justify-center gap-3 py-2">
        <span className="flex-1 text-right font-heading font-bold text-lg text-white">{fighter_a}</span>
        <span className="w-9 h-9 rounded-full bg-red-500/15 border border-red-500/40 flex items-center justify-center text-red-400 shrink-0">
          <Swords className="w-4 h-4" />
        </span>
        <span className="flex-1 text-left font-heading font-bold text-lg text-white">{fighter_b}</span>
      </div>
      <div className="text-center text-[11px] tracking-widest text-slate-500 font-bold">{weight_class}</div>
      <div className="border-t border-white/5 pt-2.5 space-y-1.5 text-xs text-slate-400">
        <div className="inline-flex items-center gap-1"><Calendar className="w-3.5 h-3.5" /> {fmt(start)}</div>
        {location && <div className="flex items-center gap-1"><MapPin className="w-3.5 h-3.5" /> {location}</div>}
      </div>
      {moneyline && (
        <div className="text-center bg-black/40 rounded-lg py-1.5">
          <span className="text-[9px] text-slate-500 tracking-wide">MONEYLINE </span>
          <span className="text-[11px] font-mono-num font-bold text-white">{moneyline}</span>
        </div>
      )}
    </div>
  );
}
